import { createContext, useState } from "react";

export const EditVariantFormContext = createContext();

export const EditVariantFormContextProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);

    const defaultFormErrors = {
        VarientMrp: "",
        VarientPrice: '',
        VarientSize: "",
        VarientColor: "",
        VarientName: "",
        VarientQuantity: "",
        Sku: "",
        VarientImgUrl: ""
    }

    const defaultFormInputs = {
        VarientMrp: "",
        VarientPrice: '',
        VarientSize: "",
        VarientColor: "",
        VarientName: "",
        VarientQuantity: "",
        Sku: ""
    }

    const [formErrors, setFormErrors] = useState(defaultFormErrors);
    const [formInputs, setFormInputs] = useState(defaultFormInputs);

    const [productImages, setProductImages] = useState([]);

    const contextValue = {
        loading,
        setLoading,
        productImages,
        setProductImages,
        formErrors,
        setFormErrors,
        formInputs,
        setFormInputs,
        defaultFormErrors,
    };

    return (
        <EditVariantFormContext.Provider value={ contextValue }>
            { children }
        </EditVariantFormContext.Provider>
    );
}
